import React, { useState } from "react";
import { Row, Col, Card, Upload, message, Button } from "antd";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { AiOutlinePlus, IoMdDownload, MdUpload } from "react-icons/all";
import { UploadOutlined } from "@ant-design/icons";
const ShippingCostWrapper = styled(Card)`
  min-height: 200px;
  .ant-card-body {
    padding: 0;
  }

  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
  padding: 12px;
  .catalog-hover:hover {
    color: #039be5;
  }
`;

function CatalogCustomization({ getTemplateRequest, uploadFile }) {
  let history = useHistory();
  let [isOpen, setIsOpen] = useState(false);
  let [uploadedFile, setUploadedFile] = useState({});
  const props = {
    name: "file",
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      console.log("Kesa dya==>", info.file.originFileObj);
      setUploadedFile(info.file.originFileObj);
      // if (info.file.status !== "uploading") {
      //   console.log(info.file, info.fileList);
      // }
      // // if (info.file.status !== "done") {
      // //   message.success(`${info.file.name} No File Choosen`);
      // // }
      // if (info.file.status === "done") {
      //   message.success(`${info.file.name} file uploaded successfully`);
      // } else if (info.file.status === "error") {
      //   message.error(`${info.file.name} file upload failed.`);
      // }
    },
  };
  return (
    <Row>
      <Col xl={24} xs={24} sm={24} lg={24} md={24}>
        <ShippingCostWrapper>
          <Row justify="start">
            <Col xl={24}>
              <h5 className="text-left" style={{ padding: "5px 5px 10px 5px" }}>
                Catalog Customization
              </h5>
            </Col>
          </Row>
          <Row className="pointer-cursor">
            <Col xl={4} xs={5} sm={5} md={4} lg={4}>
              <AiOutlinePlus size="25" />
            </Col>
            <Col xl={15}>
              <p
                className="pointer-cursor  text-left catalog-hover"
                onClick={() =>
                  history.push({
                    pathname: "/catalog/new",
                    state: { fromCustom: true },
                  })
                }
              >
                Build Your own product
              </p>
            </Col>
          </Row>
          <Row className="pointer-cursor">
            <Col xl={4} xs={5} sm={5} md={4} lg={4}>
              <IoMdDownload size="25" />
            </Col>
            <Col xl={15}>
              <p
                className="pointer-cursor text-left catalog-hover"
                onClick={() => getTemplateRequest()}
              >
                Request for a Template
              </p>
            </Col>
          </Row>
          <Row className="pointer-cursor ">
            <Col xl={4} xs={5} sm={5} md={4} lg={4}>
              <MdUpload size="25" />
            </Col>
            <Col xl={16} xs={16} sm={8} lg={18}>
              <p
                className="pointer-cursor  text-left catalog-hover"
                onClick={() => setIsOpen(!isOpen)}
              >
                Upload Product Catalogue Template
              </p>
            </Col>
          </Row>
        </ShippingCostWrapper>

        {isOpen && (
          <ShippingCostWrapper
            style={{ backgroundColor: "rgb(242, 242, 241)" }}
          >
            <Row className="pointer-cursor" justify="start">
              <Col span={12}>
                <Upload {...props}>
                  <Button style={{ backgroundColor: "#26a69a", color: "#fff" }}>
                    ADD A FILE
                  </Button>
                </Upload>
              </Col>

              {uploadedFile.name && (
                <Col span={12}>
                  <Button
                    style={{ backgroundColor: "#f57c00", color: "#fff" }}
                    onClick={() => uploadFile({ file: uploadedFile })}
                  >
                    Upload
                  </Button>
                </Col>
              )}

              {!uploadedFile.name && (
                <Col span={12}>
                  <p>{"No File Chosen"}</p>
                </Col>
              )}
            </Row>
          </ShippingCostWrapper>
        )}
      </Col>
    </Row>
  );
}
export default CatalogCustomization;
